import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { LocalStorageKey, NightMode } from "@model";
import { LocalStorageService } from "../persistance";

@Injectable({ providedIn: "root" })
export class NightModeService {
  private _isNightMode$ = new BehaviorSubject<boolean>(false);
  isNightMode$ = this._isNightMode$.asObservable();

  constructor(private _localStorageService: LocalStorageService) {}

  initialSetupNightMode(): void {
    const localStorageValue = this._localStorageService.get(LocalStorageKey.NIGHT_MODE);
    const isNightMode = localStorageValue === NightMode.ON;
    this._setNightMode(isNightMode);
  }

  toggleNightMode(): void {
    this._setNightMode(!this._isNightMode$.value);
  }

  private _setNightMode(nightMode: boolean): void {
    this._isNightMode$.next(nightMode);
    const newValue = nightMode ? NightMode.ON : NightMode.OFF;
    this._localStorageService.set(LocalStorageKey.NIGHT_MODE, newValue);
  }
}
